//Base_URL
export const BASE_URL = "https://api.nanny-line.com";
export const UI_BASE_URL = "https://nanny-line.com";
export const PAYPAL_CLIENT_ID = "Af8Ek0ypC3Abs8eacPJqQ39lUOpuGF8OSVy1djBDP-SPRVsaQBZuDGLN0KZlGRg9tbuYpRsIyeuLtfsv"
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_2jEmM8AptYGPMedu5LCewzdf'



// export const BASE_URL = "http://localhost:8000";
// export const UI_BASE_URL = "http://localhost:3000";
// export const PAYPAL_CLIENT_ID = "AbAtJOzXPsqsrO0T_yxROjqEhpyVTl_5-tTN9DJy8s6Qten3ojXhI16zjcX-xQuxIxPZfaVsPG0v-bne"
// export const STRIPE_PUBLISHABLE_KEY = 'pk_test_lTQlClwcnwQjs3Am2NSFga8i'






// Auth
export const userLoginApi = "/v1/common/login"
export const userSignUpApi = "/v1/common/signUp"
export const verifyOtpApi = "/v1/common/otpVerifications"
export const getNaniesByCategory = "/v1/user/getNanniesByCategory"

//Api Name
export const OngoingUserApi = "/v1/user/getMyBookings?type=0"
export const upcommingUserApi = "/v1/user/getNanniesBookings"
export const UserprofileApi = "/v1/user/profile"
export const UserEditProfileApi = "/v1/user/updateProfile"
export const AddratingbookingApi = "/v1/user/addRatingToBooking"
export const addressUserApi = "/v1/user/getAddresses"

//Nanny Api's
export const profileNanny = "/v1/nanny/profile"
export const profileNannyById = "/v1/user/getNannyProfile"
export const updateProfileNanny = "/v1/nanny/updateProfile"
export const updateBookingStatusApi = "/v1/nanny/updateBookingStatus"
export const DocumentsnannyApi = "/v1/nanny/getDocuments"
export const getAllCategoriesApi = "/v1/nanny/getAllCategories?skip=0&limit=10&type=0"
export const uploadDocumentsApi = "/v1/nanny/uploadDocuments"
export const gettimingApi = "/v1/nanny/getTimings"
export const updateTimingsApi = "/v1/nanny/updateTimings"
export const deleteTimingsApi = "/v1/nanny/deleteTimings"
export const NannyBookingApi = "/v1/nanny/getMyBookings"
export const UpdateNannyCatgories = "/v1/nanny/updateNannyCatgories"
export const categoriesApi = "/v1/user/categories"
export const categoryDetailsApi = "/v1/admin/categories/detail"
export const getStripeIntent = "/v1/user/getStripeIntent"

export const getAllPaymentsApi = "/v1/user/payment/all"
export const getAllNannyPaymentsApi = "/v1/nanny/payment/all"


//Common Api's
export const changePassword = "/v1/common/changePassword"
export const uploadFileApi = "/v1/upload"
export const chathistoryApi = "/v1/common/getChatHistory"

export const stripeConnectApi = "/v1/nanny/stripe-connect";
export const stripeDisconnectApi = "/v1/nanny/stripe-disconnect"
export const stripeAccountLisnStatusUpdateApi = "/v1/nanny/updateStripeConnectId"

export const verifyResetPasswordOtpApi = "/v1/common/verifyForgotPasswordOTP"
export const restPasswordForgot = "/v1/common/resetPassword"
export const nannyNotificationApi = "/v1/nanny/notifications"
export const userNotificationApi = "/v1/user/notifications"

// Paypal
export const paypalAuthToken = "/v1/user/paypal/client-token"
export const paypalPaymentIntentSecret = "/v1/user/paypal/orders"
export const paypalOrderCapture = "/v1/user/paypal/orders/"

export const paypalConnectApi = "/v1/nanny/paypal-connect"
export const paypalDisconnectApi = "/v1/nanny/paypal-disconnect"
export const paypalAccountLisnStatusUpdateApi = "/v1/nanny/updatePaypalConnectedId"
export const bookingPriceApi = "/v1/user/getBookingPrices"
export const getTravellInfoApi = "/v1/user/booking/distance"
export const nannyProfileStatusApi = "/v1/nanny/profile/status"
export const requestPhoneChangeApi = "/v1/common/requestPhoneChange"


export const priceDateCriteria = {
    'specialdates': {
        dates: ['12-24', '12-25', '12-26', '12-31', '01-01'],
        charge: 2
    },
    'bankholiday': {
        dates: ['06-01', '10-12', '08-15', '11-01', '01-06'],
        charge: 1.5
    }
}

export const lateNightEndTaxyFee = 15.0
export const lateNightSatartTaxyFee = 20.0
export const extraChildrenAddPrice = 4.0
export const travellingCostFixed = 15.0
export const travellingCostTime = 30
export const travellingDistanceLimit = 20

export const Google_api_key = "AIzaSyC9tma-o_bhWEIGAabUP5vgLUBKa-ip9Xw"